import { Component, Vue } from 'vue-property-decorator'

import CACA1030ResponseModel from '@/api/data/CAC/CACA1030/CACA1030ResponseModel'
import CACG1030ViewModel from './CACG1030ViewModel'
import CACG1030Service from './CACG1030Service'

import CACG1010ParamModel from '../CACG1010/CACG1010ParamModel'
import CommonUtil from '@/common/utils/CommonUtil'
import { fixedContent } from '@/assets/js/main.js'

@Component({
  name: 'CACG1030',
  components: {}
  })
export default class CACG1030Controller extends Vue {
  private SCALE_VALUE = 8
  private DEFAULT_YEAR_SELECTED = 0
  private COLOR_LIST = [
    '#e5413c',
    '#506BB7',
    '#AEDE49',
    '#FA9B3C',
    '#386C03',
    '#E075B2',
    '#57B8D9',
    '#CAA9DE'
  ]

  private cacg1030ViewModel: CACG1030ViewModel = {
    hikakuProductLst: [
      {
        productNameInformal: '',
        monthlyChartLst: [
          {
            monthlyChartBaseDate: '',
            monthlyChartValue: null
          }
        ]
      }
    ],

    dataChart: [],

    prdSelectedArr: null
  }

  private caca1030ResponseModel: CACA1030ResponseModel =
    new CACA1030ResponseModel()

  private cacg1030Service: CACG1030Service = new CACG1030Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    this.init()
    .then(() => {
      const dataChart = this.cacg1030ViewModel.dataChart || [];

      if (dataChart?.length > 3 && Array.isArray(dataChart[3]) && dataChart[3]?.length > 0) {
        window.addEventListener('orientationchange', this.refreshPage);
      }
    })
  }
  
  beforeDestroy() {
    window.removeEventListener('orientationchange', this.refreshPage);
  }

  private refreshPage() {
    location.reload();
  }

  /**
   * 初期処理
   */
  private async init() {
    const prdSelectedArr = this.$route.query.productInfo
      ? JSON.parse(this.$route.query.productInfo?.toString())
      : ''

    this.caca1030ResponseModel = await this.cacg1030Service.callAPICACA1030(
      prdSelectedArr
    )

    this.cacg1030ViewModel.hikakuProductLst =
      this.caca1030ResponseModel.hikakuProductLst
    if (CommonUtil.isNotEmpty(this.caca1030ResponseModel.hikakuProductLst)) {
      let isNotNull = true
      for (
        let index = 0;
        index < this.caca1030ResponseModel.hikakuProductLst.length;
        index++
      ) {
        isNotNull = CommonUtil.isNotNullArray(
          this.caca1030ResponseModel.hikakuProductLst[index].monthlyChartLst,
          ['monthlyChartValue']
        )
        if (isNotNull) {
          break
        }
      }

      if (isNotNull) {
        this.caca1030ResponseModel.hikakuProductLst.forEach(
          (hikakuProduct, index) => {
            this.cacg1030ViewModel.hikakuProductLst[index].productNameInformal =
              hikakuProduct.productNameInformal
            if (hikakuProduct.monthlyChartLst) {
              this.cacg1030ViewModel.hikakuProductLst[index].monthlyChartLst =
                hikakuProduct.monthlyChartLst
            }
          }
        )

        const dataChart = this.cacg1030Service.createDataChart(
          this.cacg1030ViewModel
        )
        const dataConvert1Y = this.cacg1030Service.convertDataChart(
          dataChart,
          108
        )
        const dataConvert3Y = this.cacg1030Service.convertDataChart(
          dataChart,
          84
        )
        const dataConvert5Y = this.cacg1030Service.convertDataChart(
          dataChart,
          60
        )
        const dataConvert10Y = this.cacg1030Service.convertDataChart(
          dataChart,
          0
        )

        this.cacg1030ViewModel.dataChart.push(dataConvert1Y)
        this.cacg1030ViewModel.dataChart.push(dataConvert3Y)
        this.cacg1030ViewModel.dataChart.push(dataConvert5Y)
        this.cacg1030ViewModel.dataChart.push(dataConvert10Y)
      }
    }

    this.cacg1030ViewModel.prdSelectedArr =
      this.$route.query.productInfo?.toString() ?? ''
  }

  /**
   *運用商品一覧（CACG1010）画面に遷移する。
   */
  private changeProductCompare() {
    const cacg1010ParamModel: CACG1010ParamModel = {
      productInfo: this.cacg1030ViewModel.prdSelectedArr
    }

    this.$router.push({
      name: 'cacg1010',
      query: cacg1010ParamModel
    })
  }

  /**
   *運用商品一覧（CACG1010）画面に遷移する。
   */
  private gotoCACG1010() {
    this.$router.push({ name: 'cacg1010' })
  }
}
